import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';

const EmptyClasseState = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center py-12">
      <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
      <h2 className="text-xl font-semibold text-gray-900 mb-2">Classe non spécifiée</h2>
      <p className="text-gray-500 mb-4">Veuillez sélectionner une classe pour voir ses bulletins.</p>
      <button
        onClick={() => navigate('/bulletins-notes')}
        className="px-4 py-2 bg-[#202654] text-white rounded-lg hover:bg-[#202654]/90 transition-colors"
      >
        Retour aux Bulletins
      </button>
    </div>
  );
};

export default EmptyClasseState;